module.exports = __webpack_public_path__ + "media/images/icons/SVG/049-bbcf5a6fe05af4c8842b96879399f6b1.svg";